import React from "react";
import styled from "styled-components";

interface HeaderProps {
  fontSize: number;
}

const SectionHeader = (props: any) => {
  const { title, fontSize } = props;
  return <HeaderText fontSize={fontSize}>{title}</HeaderText>;
};

const HeaderText = styled.div<HeaderProps>`
  margin: 1.5rem 0;
  font-family: HelveticaNeue-Medium;
  font-size: ${(p) => `${p.fontSize}px`};
  color: #060606;
`;

export default SectionHeader;
